module.exports={"(optional)":"(opcional)","(required)":"(necesario)"};